module.exports = __webpack_public_path__ + "img/DoubleCheckIcon.c9ed94db.svg";